import { SelectOption } from '@fleet-beat/core';

export enum MalfunctionDiagnosticCode {
  P = 'P',
  E = 'E',
  T = 'T',
  L = 'L',
  R = 'R',
  S = 'S',
  O = 'O',
}

export const MalfunctionDiagnosticOptions: SelectOption[] = [
  { value: MalfunctionDiagnosticCode.P, label: 'Power compliance malfunction' },
  { value: MalfunctionDiagnosticCode.E, label: 'Engine synchronization compliance malfunction' },
  { value: MalfunctionDiagnosticCode.T, label: 'Timing compliance malfunction' },
  { value: MalfunctionDiagnosticCode.L, label: 'Positioning compliance malfunction' },
  { value: MalfunctionDiagnosticCode.R, label: 'Data recording compliance malfunction' },
  { value: MalfunctionDiagnosticCode.S, label: 'Data transfer compliance malfunction' },
  { value: MalfunctionDiagnosticCode.O, label: 'Other ELD detected malfunction' },
];

export enum DataDiagnosticCode {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
}

export enum CombinedMalfunctionCode {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  P = 'P',
  E = 'E',
  T = 'T',
  L = 'L',
  R = 'R',
  S = 'S',
  O = 'O',
}

export const DataDiagnosticOptions: SelectOption[] = [
  { value: DataDiagnosticCode.One, label: 'Power data diagnostic event' },
  { value: DataDiagnosticCode.Two, label: 'Engine synchronization data diagnostic event' },
  { value: DataDiagnosticCode.Three, label: 'Missing required data elements data diagnostic event' },
  { value: DataDiagnosticCode.Four, label: 'Data transfer data diagnostic event' },
  { value: DataDiagnosticCode.Five, label: 'Unidentified driving records data diagnostic event' },
  { value: DataDiagnosticCode.Six, label: 'Other ELD identified diagnostic event' },
];

export const CombinedMalfunctionOptions: SelectOption[] = [
  { value: MalfunctionDiagnosticCode.P, label: 'Power compliance malfunction' },
  { value: MalfunctionDiagnosticCode.E, label: 'Engine synchronization compliance malfunction' },
  { value: MalfunctionDiagnosticCode.T, label: 'Timing compliance malfunction' },
  { value: MalfunctionDiagnosticCode.L, label: 'Positioning compliance malfunction' },
  { value: MalfunctionDiagnosticCode.R, label: 'Data recording compliance malfunction' },
  { value: MalfunctionDiagnosticCode.S, label: 'Data transfer compliance malfunction' },
  { value: MalfunctionDiagnosticCode.O, label: 'Other ELD detected malfunction' },
  { value: DataDiagnosticCode.One, label: 'Power data diagnostic event' },
  { value: DataDiagnosticCode.Two, label: 'Engine synchronization data diagnostic event' },
  { value: DataDiagnosticCode.Three, label: 'Missing required data elements data diagnostic event' },
  { value: DataDiagnosticCode.Four, label: 'Data transfer data diagnostic event' },
  { value: DataDiagnosticCode.Five, label: 'Unidentified driving records data diagnostic event' },
  { value: DataDiagnosticCode.Six, label: 'Other ELD identified diagnostic event' },
];

export const GeneralMalfunctionOptions: SelectOption[] = [
  ...MalfunctionDiagnosticOptions,
  ...DataDiagnosticOptions,
].map((o: SelectOption) => {
  return {
    value: o.label,
    label: o.label,
  };
});
